import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Drawer, Dialog, FormControlLabel, Menu, CardHeader, Slide, MenuItem, Radio, RadioGroup, Button, CircularProgress, AppBar, Toolbar, IconButton, Typography, Divider } from '@material-ui/core'
import { index, release, destroy } from '../../../store/actions/roulette.action'
import { changeScreen, changeScreenB } from '../../../store/actions/navigation.action'
import { MdKeyboardBackspace } from 'react-icons/md'
import { FaPencilAlt, FaTrash, FaGripHorizontal, FaCircle } from 'react-icons/fa'
import { FcFilingCabinet, FcLock } from 'react-icons/fc'
import { MdMoreHoriz } from 'react-icons/md'
import { Confirm } from '../../components'
import Detail from './detail'
import Fullname from '../../components/Fullname'


const Roulette = (props) => {
    const dispatch = useDispatch()
    const { awards } = useSelector(state => state.rouletteReducer)
    const campaign_id = (props.uid) ? props.uid : null;

    const [isLoad, setLoad] = React.useState(true)
    const [isLoading, setLoading] = React.useState(true)

    const [status, setStatus] = React.useState(1)
    const [view, setView] = React.useState('default')
    const [isMenu, setMenu] = React.useState(false)

    const [detail, setDetail] = React.useState({
        id: null,
        open: false
    })

    const [state, setState] = React.useState({
        isDeleted: null,
        menuEl: null,
        confirmEl: null
    })

    React.useEffect(() => {
        _index()
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [status])

    const _index = () => {
        setLoad(true)
        dispatch(index({
            campaign_id: campaign_id,
            status: status
        })).then(() => {
            setLoad(false)
            setLoading(false)
        })
    }

    const handlePage = (page, campaign_id = null, id = null) => {
        dispatch(changeScreenB({
            open: true,
            type: page,
            props: {
                campaign_id: campaign_id,
                uid: id
            }
        }))
    }

    const _release = (id) => {
        dispatch(release(id, campaign_id, status))
    }

    const _destroy = (id) => {
        setState({ isDeleted: id })
        dispatch(destroy(id)).then(res => res && setState({ isDeleted: null }))
    }

    const _detail = (id) => {
        setDetail({
            id: id,
            open: true
        })
    }

    const Transition = React.forwardRef((props, ref) => {
        return <Slide direction="up" ref={ref} {...props} />
    })

    return (
        <>
            <AppBar position="fixed">
                <Toolbar>
                    <IconButton onClick={() => dispatch(changeScreen({ open: false }))} edge="start" color="inherit">
                        <MdKeyboardBackspace />
                    </IconButton>
                    <Typography variant="h6">Roleta</Typography>
                    
                    <Button onClick={() => handlePage('roulette-create', campaign_id)} color="inherit" className="ms-auto">
                        Cadastrar
                    </Button>
                </Toolbar>
            </AppBar>

            <Dialog
                open={detail.open}
                maxWidth="sm"
				style={{width: '100%'}}
                onClose={() => setDetail({ id: null, open: false })}
                className="center"
            >   
                <Detail view={view} uid={detail.id} onClose={() => setDetail({ id: null, open: false })}/>
            </Dialog>


            <div className="mt-5 pt-1 bg-clear min-vh-100">

            {(isLoading) ? <div className="d-flex justify-content-center mt-5 pt-5"> <CircularProgress /> </div> :
                <>
                    <div className="card-body d-flex justify-content-between">
                        <label className="label-custom m-0 bs-color">{awards.length.toLocaleString('pt-BR', {style: 'decimal'})} registro(s)</label>
                        <IconButton className="p-0 bs-color" onClick={() => setMenu(true)}>
                            <FaGripHorizontal size="1.2em" />
                        </IconButton>
                    </div>

                    <Drawer 
                        anchor="bottom"
                        open={isMenu}
                        onClose={() => setMenu(false)}
                    >
                        <div className="card card-body bs-bg">
                            <label className="fw-bold label-custom bs-color-b"><FaGripHorizontal size={20} className="me-2" />MODOS DE VIZUALIZAÇÃO</label>

                            <div className="mt-3 mb-3">
                                <RadioGroup
                                    name="type"
                                    value={view}
                                    onChange={text => {
                                        setView(text.target.value)
                                    }}
                                    className="fw-bold bs-color-b"
                                >
                                    <FormControlLabel value="default" control={<Radio color="primary" />} label="PADRÃO" />
                                    <FormControlLabel value="list-abrev" control={<Radio color="primary" />} label="LISTA ABREVIADA" />
                                    <FormControlLabel value="list-clean" control={<Radio color="primary" />} label="LISTA CLEAN" />
                                </RadioGroup>
                            </div>
                        </div>
                    </Drawer>

                    <div className="card p-3 mb-2 bs-bg">
                        <div>
                            <RadioGroup
                                row
                                name="type"
                                value={parseInt(status)}
                                onChange={text => setStatus(text.target.value)}
                                className="fw-bold bs-color-b"
                            >
                                <FormControlLabel value={1} control={<Radio color="primary" />} label="TODOS" />
                                <FormControlLabel value={2} control={<Radio color="primary" />} label="DISPONIVEIS" />
                                <FormControlLabel value={3} control={<Radio color="primary" />} label="VENDIDOS" />
                            </RadioGroup>
                        </div>
                    </div>

                    {(isLoad) ? <div className="d-flex justify-content-center m-5 p-5"> <CircularProgress /> </div> :
                        <>
                        {(awards.length < 9) &&
                            <div className="alert alert-warning mt-3" role="alert">
                                <strong>Para a Roleta aparecer precisa cadastrar no minimo 9 prêmios</strong>
                            </div>
                        }
                        {(awards.length < 1) &&
                            <div className="card card-body mt-3 bs-bg">
                                <div className="text-center mt-5 pt-5 mb-5 pb-5">
                                    <FcFilingCabinet size="70" />
                                    <h6 className="mt-4 text-muted bs-color">Nenhum registro encontrado</h6>
                                </div>
                            </div>
                        }

                        {(awards.length > 0) &&
                            <>

                            {(view === 'default' || view === 'list-abrev' || view === 'list-clean') &&
                                <>
                                  {awards.map((item, index) => (
                                    <div className="card pointer bs-bg list-items" key={index}>
                                        <CardHeader
                                            className={view === 'list-clean' ? "pt-0 pb-0" : "pt-2 pb-2"}
                                            avatar={
                                                <FaCircle size={22} className={item.title_number && !item.user_id ? 'blink' : ''} onClick={() => _detail(item.id)} color={(item.title_number && !item.user_id) ? '#ffc107' : (item.user_id ? '#6c757d' : '#28a745')}/>
                                            }
                                            title={<h6 className="m-0 fw-bold bs-color-b" onClick={() => _detail(item.id)}>{item.title ? item.title.substring(0,25) : item.title}</h6>}
                                            subheader={(view !== 'list-clean') && <>
                                                {item.user_id &&
                                                    <>
                                                    <span onClick={() => _detail(item.id)} className="d-block bs-color">{<Fullname fullName={item.user?.name ? item.user?.name.substring(0,25) : item.user?.name} />}</span>
                                                    {(view === 'default') &&
                                                        <small className="bs-color" onClick={() => _detail(item.id)}>{new Intl.DateTimeFormat('pt-BR', {year: '2-digit', month: '2-digit',day: '2-digit'}).format(new Date(item.time_at))} {new Intl.DateTimeFormat('pt-BR', {hour: '2-digit', minute: '2-digit'}).format(new Date(item.time_at))}</small>
                                                    }
                                                    </>
                                                }
                                            </>}
                                            
                                            action={
                                                <>
                                                {!item.user_id &&
                                                    <h6 className="fw-bold pt-3 pe-3 bs-color">
                                                        <MdMoreHoriz id={index} onClick={event => setState({ menuEl: event.currentTarget })} size={28} />
                                                    </h6>
                                                }
                                                </>
                                            }
                                        />

                                        {(Boolean(state.menuEl)) &&
                                            <Menu
                                                anchorEl={state.menuEl}
                                                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                                                TransitionComponent={Transition}
                                                open={(index === parseInt(state.menuEl.id))}
                                                onClose={() => setState({ menuEl: null })}
                                            >
                                                <MenuItem 
                                                    onClick={() => setState({ releaseEl: item.id })}
                                                    className="bs-color-b"
                                                >
                                                    <FcLock size="1.2em" className="me-4" /> <strong>{item.title_number && !item.user_id ? 'Restaurar' : 'Liberar Prêmio'}</strong>
                                                </MenuItem>

                                                <Divider />

                                                <MenuItem 
                                                    onClick={() => {
                                                        setState({ menuEl: null })
                                                        handlePage('roulette-edit', campaign_id, item.id)
                                                    }}
                                                    className="bs-color-b"
                                                >
                                                    <FaPencilAlt size="1.2em" className="me-4" /> <strong>Editar</strong>
                                                </MenuItem>

                                                <Divider />

                                                <MenuItem 
                                                    onClick={() => setState({ confirmEl: item.id })}
                                                    className="bs-color-b"
                                                >
                                                    <FaTrash color="#dc3545" size="1.2em" className="me-4" /> <strong>Apagar</strong>
                                                </MenuItem>
                                                <div className='mt-3'></div>
                                            </Menu>
                                        }

                                        {(state.confirmEl === item.id) && 
                                            <Confirm
                                                open={(item.id === state.confirmEl)}
                                                onClose={() => setState({ confirmEl: null })}
                                                onConfirm={() => _destroy(item.id)}
                                                title="Tem certeza que deseja remover ?"
                                            />
                                        }

                                        {(state.releaseEl === item.id) && 
                                            <Confirm
                                                secure
                                                text={item.title_number && !item.user_id ? "restaurar" : "liberar"}
                                                open={(item.id === state.releaseEl)}
                                                onClose={() => setState({ releaseEl: null })}
                                                onConfirm={() => _release(item.id)}
                                                title={item.title_number && !item.user_id ?  "Tem certeza que deseja restaurar o padrão?" : "Tem certeza que deseja liberar esse prêmio?"}
                                            />
                                        }
                                    </div>
                                ))}
                                </>
                            }
                            </>
                        }
                    </>
                    }
                </>
            }
            </div>
        </>
    )
}

export default Roulette